import { useEffect, useState, useCallback, useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar, { SidebarContent } from "./Sidebar";
import { Toaster } from "sonner";
import { apiClient } from "@/lib/api";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { List, FileText } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function Layout() {
  const [stats, setStats] = useState([]);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const refresh = useCallback(async () => {
    try {
      const { data } = await apiClient.get("/stats");
      setStats(data);
    } catch (err) {
      console.error("Failed to refresh stats", err);
    }
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 15000);
    return () => clearInterval(id);
  }, [refresh]);

  // Close drawer on route change
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const outletContext = useMemo(() => ({ stats, refresh }), [stats, refresh]);

  return (
    <div className="flex min-h-screen bg-zinc-50">
      <Sidebar stats={stats} />

      <div className="flex-1 flex flex-col min-w-0">
        {/* Mobile top bar with hamburger */}
        <div className="lg:hidden sticky top-0 z-30 bg-white border-b border-zinc-200 flex items-center justify-between px-4 h-14" data-testid="mobile-header">
          <Link to="/dashboard" className="flex items-center gap-2" data-testid="mobile-logo-home">
            <img src="/logo-ecocasse.png" alt="Ecocasse" className="w-7 h-7 object-contain" />
            <div>
              <div className="font-heading font-semibold text-sm leading-none">Portail d'activité</div>
              <div className="text-[9px] uppercase tracking-[0.2em] font-semibold text-zinc-500 mt-0.5">Ecocasse</div>
            </div>
          </Link>

          <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
            <SheetTrigger asChild>
              <button
                className="p-2 -mr-2 hover:bg-zinc-100 transition-colors"
                data-testid="mobile-menu-trigger"
                aria-label="Ouvrir le menu"
              >
                <List size={22} weight="bold" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="w-72 p-0 bg-white">
              <div className="h-full overflow-y-auto">
                <SidebarContent stats={stats} onNavigate={() => setMobileOpen(false)} />
              </div>
            </SheetContent>
          </Sheet>
        </div>

        <Outlet context={outletContext} />
      </div>

      <Toaster position="top-right" richColors />
    </div>
  );
}
